
    // this file was auto generated by python script
    import Target from './Target';
    export default Target;
    